import {type ClassValue, clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';


export function cn(...inputs: ClassValue[]) {
    const classValues = clsx(inputs);
    return twMerge(classValues);
}
